import { shallowEqual, useSelector } from 'react-redux';

import { HirerType } from 'src/graphql/generated';
import type AppState from 'src/types/appState';

export const useCanUpdateExpiryDate = (): boolean => {
  const { hasAgent, hirerType } = useSelector(
    (state: AppState) => ({
      hasAgent: state.session.hirerAccount.hasAgent,
      hirerType: state.session.hirerAccount.hirerType,
    }),
    shallowEqual,
  );

  return hasAgent || hirerType === HirerType.GOVERNMENT;
};
